module.exports = __webpack_public_path__ + "static/media/s2.9eb1ab17.jpg";